import classnames from 'classnames'
import { Nav, NavItem, NavLink } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBook,
  faMessage,
  faNoteSticky,
} from '@fortawesome/free-solid-svg-icons'
import { useDispatch, useSelector } from 'react-redux'
import { setCurrentTabViewCourse } from 'store/Course/actions'

const DrawerNav = () => {
  const course = useSelector((state) => state.courses)
  const { currentTabViewCourse, allowCourseComments } = course

  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}

  const dispatch = useDispatch()

  const handleTab = (tab) => {
    dispatch(setCurrentTabViewCourse(tab))
  }

  return (
    <Nav
      className='nav-fill flex-column flex-sm-row'
      id='tabs-text'
      pills
      role='tablist'
    >
      <NavItem>
        <NavLink
          role='tab'
          aria-selected={currentTabViewCourse === 'lessons'}
          className={classnames(
            `mb-sm-3 mb-md-0 nav-pill-cursor text-dark ${
              currentTabViewCourse === 'lessons'
                ? 'border border-dark shadow-none'
                : ''
            } `
          )}
          onClick={() => handleTab('lessons')}
        >
          <FontAwesomeIcon icon={faBook} className='pr-2' />
          {language.courses ? language.courses.lessons : null}
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          role='tab'
          aria-selected={currentTabViewCourse === 'notes'}
          className={classnames(
            `mb-sm-3 mb-md-0 nav-pill-cursor text-dark ${
              currentTabViewCourse === 'notes'
                ? 'border border-dark shadow-none'
                : ''
            } `
          )}
          onClick={() => handleTab('notes')}
        >
          <FontAwesomeIcon icon={faNoteSticky} className='pr-2' />
          {language.courses ? language.courses.notes : null}
        </NavLink>
      </NavItem>
      {allowCourseComments ? (
        <NavItem>
          <NavLink
            role='tab'
            aria-selected={currentTabViewCourse === 'disscusions'}
            className={classnames(
              `mb-sm-3 mb-md-0 nav-pill-cursor text-dark border ${
                currentTabViewCourse === 'disscusions'
                  ? 'border border-dark shadow-none'
                  : ''
              } `
            )}
            onClick={() => handleTab('disscusions')}
          >
            <FontAwesomeIcon icon={faMessage} className='pr-2' />
            Disscussions
          </NavLink>
        </NavItem>
      ) : null}
    </Nav>
  )
}

export default DrawerNav
